var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAssaultRifle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 60,
    viewBox: "0 0 120 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.09644 20.7285V23.5095",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.05542 22.842H14.6984L29.3399 16.656V12.8745",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5642 20.091V12.795",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7275 20.091V12.795",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5398 20.091V12.795",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9441 21.9689H36.9416",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8992 21.9689H41.8982",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8552 21.9689H46.8527",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7527 21.9689H55.7502",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7078 21.9689H60.7068",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6638 21.9689H65.6613",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3982 23.7525H80.2457V21.969L82.3292 21.3585H87.9617",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2087 18.909V23.7525",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5593 23.7525L77.8248 25.611V30.2595",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8826 30.759L82.5826 28.8765H85.7641H110.036",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M111.991 25.611H86.1013L84.7393 26.1315C84.4063 26.259 84.1873 26.5785 84.1873 26.934V27.657C84.1873 28.023 84.4198 28.3485 84.7648 28.4685L85.7638 28.875",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7389 37.767L80.9724 39.9735",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M114.568 31.8045H106.036L92.8601 36.1125",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M111.992 25.611H110.035V31.806H111.992V25.611Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M113.292 25.611H111.993V28.9335H113.292C114.21 28.9335 114.952 28.1895 114.952 27.273C114.952 26.3565 114.208 25.6125 113.292 25.6125V25.611Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8605 36.333V37.356C92.8605 38.5035 91.863 39.4335 90.6345 39.4335H89.802C88.9995 39.4335 88.281 38.9685 87.999 38.268L85.8465 32.9235C85.2765 31.509 86.397 29.9985 88.0155 29.9985H90.336C91.7295 29.9985 92.8605 31.053 92.8605 32.355V36.333",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0685 35.8455H55.989V33.18L59.748 31.5795H66.087C67.1805 31.5795 68.0685 32.466 68.0685 33.561V35.8455V35.8455Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9996 30.384C60.5837 30.384 61.0571 29.9105 61.0571 29.3265C61.0571 28.7424 60.5837 28.269 59.9996 28.269C59.4156 28.269 58.9421 28.7424 58.9421 29.3265C58.9421 29.9105 59.4156 30.384 59.9996 30.384Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7734 44.418V40.8705L102.235 38.295H106.206L108.781 37.197V39.2385",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9308 30.7349H44.9028C44.588 30.7349 44.3328 30.9901 44.3328 31.3049C44.3328 31.6197 44.588 31.8749 44.9028 31.8749H46.9308C47.2456 31.8749 47.5008 31.6197 47.5008 31.3049C47.5008 30.9901 47.2456 30.7349 46.9308 30.7349Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6494 23.7525V25.7085H31.1984V29.088H33.2249V27.2295V25.7085H33.7739V23.7525H30.6494Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2253 27.2295H47.7963L50.2038 26.4195V25.455H64.6473V27.06",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M90.158 21.969L92.2685 20.7285H104.432V23.64H90.158V21.969Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2683 18.0705C87.2683 18.0705 88.0723 18.774 88.9963 18.909C90.1573 19.0785 91.1713 18.465 91.1713 18.465H108.508L110.035 16.656",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9561 36.9735V33.381L28.0456 32.1915H32.9446L34.3516 33.8175V36.69",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3156 33.987C49.3156 33.4269 48.8619 32.973 48.3023 32.973C47.7427 32.973 47.2891 33.4269 47.2891 33.987V36.6045C47.2891 37.1645 47.7427 37.6185 48.3023 37.6185C48.8619 37.6185 49.3156 37.1645 49.3156 36.6045V33.987Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3329 33.987C44.3329 33.4269 43.8792 32.973 43.3196 32.973C42.76 32.973 42.3064 33.4269 42.3064 33.987V36.6045C42.3064 37.1645 42.76 37.6185 43.3196 37.6185C43.8792 37.6185 44.3329 37.1645 44.3329 36.6045V33.987Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3495 33.987C39.3495 33.4269 38.8958 32.973 38.3362 32.973C37.7766 32.973 37.323 33.4269 37.323 33.987V36.6045C37.323 37.1645 37.7766 37.6185 38.3362 37.6185C38.8958 37.6185 39.3495 37.1645 39.3495 36.6045V33.987Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6759 34.7895C32.6759 34.2295 32.2223 33.7755 31.6627 33.7755C31.1031 33.7755 30.6494 34.2295 30.6494 34.7895V37.407C30.6494 37.967 31.1031 38.421 31.6627 38.421C32.2223 38.421 32.6759 37.967 32.6759 37.407V34.7895Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3397 34.7895C29.3397 34.2294 28.8861 33.7755 28.3265 33.7755C27.7669 33.7755 27.3132 34.2294 27.3132 34.7895V37.407C27.3132 37.967 27.7669 38.421 28.3265 38.421C28.8861 38.421 29.3397 37.967 29.3397 37.407V34.7895Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3881 29.088H16.1631C16.3266 29.088 16.4586 29.22 16.4586 29.3835V32.847C16.4586 33.0105 16.3266 33.1425 16.1631 33.1425H13.3836C12.8436 33.1425 12.4041 32.703 12.4041 32.163V30.0705C12.4041 29.5275 12.8451 29.088 13.3866 29.088H13.3881Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M5.35077 20.433V20.388C5.35077 20.2245 5.21877 20.0925 5.05527 20.0925H1.79427C1.23927 20.0925 0.790771 20.5425 0.790771 21.096V23.007C0.790771 23.6355 1.30077 24.1455 1.92927 24.1455H5.05527C5.21877 24.1455 5.35077 24.0135 5.35077 23.85V23.805C5.35077 23.6415 5.48277 23.5095 5.64627 23.5095H8.82627C9.01227 23.5095 9.15177 23.34 9.11727 23.1585L8.69727 20.9685C8.67027 20.829 8.54877 20.7285 8.40627 20.7285H5.64627C5.48277 20.7285 5.35077 20.5965 5.35077 20.433V20.433Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7312 12.783L66.0992 12.294C66.2357 12.2445 66.3872 12.303 66.4577 12.429L69.7502 18.387C69.8252 18.522 69.7832 18.693 69.6527 18.7785L67.7042 20.0445C67.6562 20.076 67.6007 20.0925 67.5437 20.0925H31.8152C31.7807 20.0925 31.7447 20.0985 31.7117 20.1105L25.5902 22.386C25.4747 22.4295 25.3982 22.539 25.3982 22.6635V26.5485C25.3982 27.021 25.1717 27.465 24.7892 27.744L22.1462 29.664C21.8447 29.883 21.4817 30.0015 21.1082 30.0015H19.1402C18.8552 30.0015 18.5807 29.8935 18.3722 29.6985L15.3707 26.8995C15.3362 26.868 15.2942 26.844 15.2492 26.8305L9.69324 25.266C9.58524 25.236 9.50424 25.1475 9.48324 25.038L9.00024 22.5615L8.37024 19.335C8.25474 18.741 8.60724 18.1575 9.18624 17.982L25.8662 12.951C25.8917 12.9435 25.9187 12.939 25.9457 12.939L63.7697 12.2205C64.1702 12.213 64.5407 12.4305 64.7312 12.783L68.3642 19.53",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5703 37.8616C32.4038 38.1931 32.0603 38.4211 31.6643 38.4211C31.2668 38.4211 30.9233 38.1931 30.7568 37.8616",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2342 37.8616C29.0677 38.1931 28.7242 38.4211 28.3282 38.4211C27.9307 38.4211 27.5872 38.1931 27.4207 37.8616",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5681 37.8615L34.2916 36.738C34.3396 36.7065 34.3951 36.69 34.4536 36.69H37.3261C37.3696 37.2105 37.8046 37.6185 38.3356 37.6185C38.8666 37.6185 39.3031 37.209 39.3451 36.69H39.3481H42.3046H42.3076C42.3511 37.2105 42.7861 37.6185 43.3171 37.6185C43.8481 37.6185 44.2846 37.209 44.3266 36.69H44.3296H47.2861H47.2891C47.3311 37.2105 47.7676 37.6185 48.2986 37.6185C48.8296 37.6185 49.2661 37.209 49.3081 36.6885H49.3111L55.6696 35.847C55.6831 35.8455 55.6951 35.844 55.7086 35.844H67.7761C67.9351 35.844 68.0626 35.973 68.0626 36.1305V36.138C68.0626 36.303 68.1946 36.435 68.3581 36.435C69.9811 36.435 77.8006 36.435 79.1431 36.435C79.2631 36.435 79.3696 36.5085 79.4161 36.618C82.7596 44.688 85.4476 45.897 88.9276 46.191C91.8751 46.44 94.7041 45.015 95.5291 44.556C95.6656 44.4795 95.8381 44.5245 95.9221 44.6565L95.9356 44.6775C96.0106 44.796 96.1606 44.8455 96.2926 44.7945L108.548 40.0425C108.662 39.999 108.737 39.8895 108.737 39.7665V39.453C108.737 39.324 108.821 39.21 108.944 39.171L111.74 38.2875C111.863 38.2485 111.947 38.1345 111.947 38.0055V37.395C111.947 37.281 112.013 37.1775 112.116 37.128L117.758 34.4505C118.26 34.212 118.565 33.6915 118.526 33.138C118.403 31.377 118.155 27.525 118.197 25.608C118.233 23.9955 118.383 21.72 118.487 20.28C118.541 19.5375 117.953 18.9075 117.209 18.9075H114.564H112.298C112.134 18.9075 112.002 18.7755 112.002 18.612V18.09C112.002 18.072 112.002 18.0525 111.998 18.0345C111.785 16.776 110.436 16.6635 110.105 16.6545C110.055 16.6545 110.007 16.6395 109.964 16.6155L109.311 16.242C109.266 16.2165 109.217 16.203 109.164 16.203H91.2331C91.1896 16.203 91.1461 16.2135 91.1056 16.2315L86.1586 18.5955C86.1181 18.615 86.0746 18.624 86.0311 18.624H69.8806",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2324 37.8615H30.7579",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4597 33.1425H19.5452C19.5992 33.1425 19.6517 33.1575 19.6982 33.1845L27.4217 37.86",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6267 33.1425V30",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M114.569 30.3931V35.9686",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M114.569 18.9091V24.1516",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5232 35.502V32.661C23.5232 32.5665 23.5697 32.4765 23.6462 32.421L26.8937 30.09C26.9717 30.0345 27.0167 29.9445 27.0167 29.85V29.385C27.0167 29.2215 27.1487 29.0895 27.3122 29.0895H47.9552C47.9897 29.0895 48.0242 29.0835 48.0557 29.0715L53.5322 27.0795C53.5652 27.0675 53.5982 27.0615 53.6327 27.0615H66.9347C66.9842 27.0615 67.0337 27.0735 67.0772 27.0975L67.7882 27.489C67.8317 27.513 67.8812 27.525 67.9307 27.525H75.2282C75.2942 27.525 75.3587 27.5475 75.4097 27.588L76.1867 28.197C76.2587 28.2525 76.3007 28.3395 76.3007 28.4295V30.3555",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1033 18.627L87.8718 20.3415C87.9288 20.397 87.9618 20.4735 87.9618 20.553V22.377C87.9618 22.4925 88.0293 22.599 88.1358 22.647L90.2688 23.6115C90.3078 23.6295 90.3483 23.6385 90.3903 23.6385H93.7788C93.8418 23.6385 93.9018 23.658 93.9528 23.6955L94.4163 24.033C94.4673 24.069 94.5273 24.09 94.5903 24.09H102.191C102.239 24.09 102.287 24.078 102.33 24.0555L103.044 23.6745C103.088 23.652 103.134 23.64 103.184 23.64H108.383C108.434 23.64 108.483 23.6265 108.527 23.6025L111.842 21.753C111.935 21.7005 111.993 21.6015 111.993 21.495V18.909",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1661 34.17H71.5326C71.3691 34.17 71.2371 34.302 71.2371 34.4655V36.4365",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M114.569 24.15C115.631 24.7845 116.342 25.944 116.342 27.2715C116.342 28.599 115.631 29.7585 114.569 30.393",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8251 30.393H78.9651C78.9936 30.393 79.0221 30.3975 79.0491 30.4065C79.3251 30.4905 80.8656 31.0065 80.8656 32.031V34.1085C80.8656 34.152 80.8566 34.1955 80.8371 34.2345C80.7516 34.413 80.4711 34.9035 79.9641 34.9035H74.3451C74.2986 34.9035 74.2536 34.893 74.2131 34.872C73.9581 34.7415 73.0221 34.2165 72.9261 33.4395C72.8136 32.538 73.3746 31.1805 74.3901 30.7365C75.2916 30.342 77.8251 30.3945 77.8251 30.3945",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8478 30.8775C77.8763 31.3665 77.9018 32.3325 77.7338 33.0855C77.6783 33.3375 77.9423 33.537 78.1658 33.411L79.4693 32.6775C79.5623 32.625 79.6193 32.526 79.6193 32.4195V31.0485C79.6193 30.9225 79.5398 30.8115 79.4213 30.7695L78.8858 30.5805C78.8543 30.57 78.8213 30.564 78.7883 30.564H78.1433C77.9738 30.564 77.8388 30.7065 77.8478 30.876V30.8775Z",
    fill: "#FAFAFB",
    stroke: "#FAFAFB",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M117.989 23.9355C118.007 21.7905 118.326 20.049 118.595 18.909C116.399 18.8385 114.203 18.768 112.007 18.6975C111.969 17.622 111.659 17.202 111.363 17.025C111.029 16.8255 110.694 16.926 110.036 16.656C109.685 16.512 109.419 16.335 109.247 16.206C103.107 16.2615 96.9663 16.3155 90.8268 16.371C89.2518 17.124 87.6768 17.8755 86.1033 18.6285C80.6463 18.5355 75.1878 18.4425 69.7308 18.348C68.5998 16.302 67.4688 14.2545 66.3378 12.2085L64.7328 12.783C64.6293 12.591 64.5273 12.4005 64.4238 12.2085C51.5853 12.453 38.7453 12.696 25.9068 12.9405C20.0028 14.7675 14.0988 16.5945 8.19477 18.4215C8.28027 19.191 8.36577 19.9605 8.45127 20.73H5.35377C5.24127 20.5185 5.12877 20.3055 5.01627 20.094H0.790771V24.1485H5.35227V23.511H9.18627C9.29727 24.0795 9.40827 24.6495 9.51927 25.218C11.4528 25.7625 13.3863 26.307 15.3198 26.8515L17.2203 28.9215C15.6153 28.9785 14.0103 29.034 12.4053 29.091V33.1455H19.6278C22.0713 34.6245 24.5148 36.1035 26.9583 37.5825C27.0903 37.7655 27.3243 38.028 27.6933 38.199C27.9138 38.301 28.3803 38.52 28.8108 38.3025C29.0493 38.1825 29.1768 37.977 29.2353 37.8645C29.8083 37.9545 30.3813 38.043 30.9543 38.133C31.0158 38.1915 31.2753 38.427 31.6653 38.424C32.0358 38.4225 32.3808 38.205 32.5713 37.863C32.8338 37.692 33.0948 37.521 33.3573 37.3515C33.6948 37.1325 34.0323 36.912 34.3683 36.693H37.0293C37.1208 36.7845 37.2618 36.9195 37.4388 37.0755C37.8183 37.41 38.0118 37.5765 38.2038 37.6125C38.5023 37.668 38.8233 37.548 39.0408 37.338C39.3003 37.0875 39.3408 36.777 39.3483 36.693C40.2783 36.693 41.2083 36.693 42.1398 36.693C42.1998 36.8325 42.3198 37.0635 42.5538 37.269C42.7083 37.404 42.9543 37.62 43.3218 37.6215C43.6608 37.623 43.9878 37.4415 44.1723 37.1565C44.3163 36.9345 44.3343 36.7125 44.3343 36.6075C45.3198 36.636 46.3053 36.6645 47.2908 36.6915C47.3013 36.7875 47.3388 37.0395 47.5368 37.2675C47.5698 37.305 47.8533 37.623 48.3048 37.6215C48.6543 37.62 48.8883 37.428 49.0383 37.3065C49.3173 37.0785 49.4463 36.8085 49.5003 36.669C51.5658 36.396 53.6298 36.1215 55.6953 35.8485H68.0703V36.4395H79.3473C79.6653 37.26 79.9653 37.9125 80.1768 38.3505C81.2418 40.554 82.3998 42.138 83.7588 43.98C84.2493 44.646 84.4953 44.9775 84.6258 45.0975C86.3673 46.6935 89.0118 46.368 90.6108 46.1715C91.7538 46.0305 93.5643 45.657 95.5953 44.5275L96.0723 44.886C100.296 43.248 104.519 41.61 108.743 39.9735V39.2415C109.812 38.904 110.883 38.5665 111.953 38.2275V37.2135C114.162 36.096 116.373 34.9785 118.583 33.8595C118.493 31.3665 118.352 29.3445 118.239 27.9465C118.088 26.0775 117.981 25.2525 117.992 23.937L117.989 23.9355ZM80.8653 34.107C80.8653 34.1505 80.8563 34.194 80.8368 34.233C80.7513 34.4115 80.4708 34.902 79.9638 34.902H74.3448C74.2983 34.902 74.2533 34.8915 74.2128 34.8705C73.9578 34.74 73.0218 34.215 72.9258 33.438C72.8133 32.5365 73.3743 31.179 74.3898 30.735C75.2913 30.3405 77.8248 30.393 77.8248 30.393H78.9648C78.9933 30.393 79.0218 30.3975 79.0488 30.4065C79.3248 30.4905 80.8653 31.0065 80.8653 32.031V34.1085V34.107ZM92.8593 36.333V37.356C92.8593 38.5035 91.8618 39.4335 90.6333 39.4335H89.8008C88.9983 39.4335 88.2798 38.9685 87.9978 38.268L85.8453 32.9235C85.2753 31.509 86.3958 29.9985 88.0143 29.9985H90.3348C91.7283 29.9985 92.8593 31.053 92.8593 32.355V36.333V36.333Z",
    fill: "#FAFAFB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssaultRifle);
export default __webpack_public_path__ + "static/media/Assault Rifle.9c707263dc0c61a91110b3aa5bcbfb60.svg";
export { ForwardRef as ReactComponent };